import {
  FETCH_CLASSES_BEGIN,
  FETCH_CLASSES_FULFILLED,
  FETCH_CLASSES_REJECTED,
  FETCH_CLASS_BEGIN,
  FETCH_CLASS_FULFILLED,
  FETCH_CLASS_REJECTED,
} from "../actions/classActions";

export function classReducer(
  state = {
    loading: false,
    result: [],
    error: null,
    singleClass: [],
    loadingSingleClass: false,
  },
  action
) {
  switch (action.type) {
    case FETCH_CLASSES_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_CLASSES_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_CLASSES_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    }
    case FETCH_CLASS_BEGIN: {
      return { ...state, loadingSingleClass: true };
    }
    case FETCH_CLASS_REJECTED: {
      return { ...state, loadingSingleClass: false, error: action.payload };
    }
    case FETCH_CLASS_FULFILLED: {
      return {
        ...state,
        loadingSingleClass: false,
        singleClass: action.payload,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
